import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class NewsService {
	private db;
	news: FirebaseListObservable<News[]>;

	constructor(private firebaseService: FirebaseService) {
		this.db = firebaseService.db;
		this.loadNews();
	}

	/**
	 * Load initial data
	 */
	loadNews() {
		window.dispatchEvent(new Event('loading'));
		this.news = this.db.list('/news') as FirebaseListObservable<News[]>
		this.news.subscribe(data => {
			this.triggerDataChange();
		});

		return this.news;
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	/**
	 * Get All News
	 */
	getAllNews() {
		return this.news;
	}

	/**
	 * Get News by ID
	 * @param {string} id : Item ID
	 */
	getNews(id: string) {
		return this.db.object('/news/' + id) as FirebaseObjectObservable<News>;
	}

	/**
	 * Add new News
	 * @param {News} news
	 */
	addNews(news) {
		return this.news.push(news);
	}

	/**
	 * Update News Data
	 * @param {string} id   : Item ID
	 * @param {object} data : Updated data
	 */
	updateNews(id: string, data: News) {
		var news = this.getNews(id);
		data.updated_at = (new Date()).getTime();
		return news.update(data);
	}

	/**
	 * Delete News
	 * @param {string} id : Item ID
	 */
	deleteNews(id: string) {
		var promise = new Promise<any>((resolve, reject) => {
			if(!id){
				reject('ID must provided.');
			}
			else
			{
				var result = this.news.remove(id).then(data => {
					this.triggerDataChange();
					resolve(data);
				})
			}
		})
		return promise;
	}
}

export class News {
	$key?: string;
	title?: string = '';
	content?: string = '';
	image?: string = '';

	created_at?: number;
	updated_at?: number;

	constructor() {
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/news.service.ts